/** @jsxImportSource @emotion/react */
import React, { Fragment, useEffect, useState,useContext } from 'react'
import { Grid, Typography, Button, Slide, CircularProgress,useMediaQuery, useTheme, DialogContent, Box } from "@mui/material";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import RecordVideo from './RecordVideo';
import classes from "./style";
import { Il8nContext } from '../../../Helper/i18n';
import axios from 'axios';
import config from '../../../config';
import { getObjections } from '../../../Helper/Functions';
import Popup, { PopupTitle } from '../../CustomPopup';
import getCookie from '../../../Helper/Cookies/cookies';
import { convertFourDigitCodeToWord } from '../../../Helper/Functions';

var isRefreshOn
var codeType;
const fileReader = new FileReader()
function UploadVideo(props) {
  const theme = useTheme();
  const { toggleIPVPopup, uploadVideoProof, data, documentUploadedDetails, onVideoRemove, setLoading, setSnackBar, handleClose,getDocuments, uploadImageProof} = props
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [videoState, setVideoState] = useState({ video: [], record: false, showLoader: false, sizelimit: false })
  const uploadVideo = React.useRef(null);
  const localeText = useContext(Il8nContext)
  const [linkSentPopup, setLinkSentPopup] = useState(false)
  const [recordVideoInstruction, setRecordVideoInstruction] = useState({
    instructionPopup: false,
    uniqueCode: null,
    word:null
  })
  const [copiedText, setCopiedText] = useState("")
  const [isCopied, setIsCopied] = useState({ tab1: false, tab2: false })


  const instructions = [
    localeText?.videoProofinstruction1,
    localeText?.videoProofinstruction2,
    localeText?.videoProofinstruction3,
    localeText?.videoProofinstruction4,
    localeText?.videoProofinstruction5,
    localeText?.videoProofinstruction6
  ];

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setVideoState({...videoState, video: [data.data]})
    }
  }, [data])

  useEffect(()=>{
    if(linkSentPopup === false){
      isRefreshOn = false
    }
  },[linkSentPopup])

  const handleChange = (e) => {
    fileReader.readAsDataURL(uploadVideo.current.files[0])

    fileReader.onload = (e) => {
      const obj = {
        video: [e.currentTarget.result],
        sizelimit: false
      }
      if (uploadVideo && uploadVideo.current && uploadVideo.current.files[0].size / (1024 * 1024) > 10) {
        obj.sizelimit = true
      }
      else if (uploadVideo && uploadVideo.current && !uploadVideo.current.files[0].name.toLowerCase().includes("mp4")) {
        obj.sizelimit = true
      }
      setVideoState(obj)
    }
  }
  const cancelRecording = () => {
    setVideoState({
      ...videoState,
      record: false,
      sizelimit: false
    })
    setRecordVideoInstruction({
      instructionPopup: false,
      uniqueCode: null,
      word:null
    })
  }

  const saveRecordVideo = (src) => {
    setVideoState({
      ...videoState,
      record: false,
      video: [src],
      sizelimit: false
    })
  }

  function deleteVideo() {
    setVideoState({ ...videoState, video: [] })
    onVideoRemove()
  }

  const copyLink = (text, tab) => {
    navigator?.clipboard?.writeText(text)
        .then(() => {
            if (tab == 1) {
                setIsCopied({ ...isCopied, tab1: true })
            } else {
                setIsCopied({ ...isCopied, tab2: true })
            }
        })
        .catch(err => {
            if (tab == 1) {
                setIsCopied({ ...isCopied, tab1: false })
            } else {
                setIsCopied({ ...isCopied, tab2: false })
            }
        });
};

  const toggleSentLinkPopup = () => {
    setLinkSentPopup(!linkSentPopup)
  }

  const toggleRecordVideoInstruction = () => {
    setRecordVideoInstruction({ ...recordVideoInstruction, instructionPopup: !recordVideoInstruction })
  }

const handleRecordVideo = () => {
  setLoading(true);
  axios.get(process.env.REACT_APP_API_URL + config.getVideoUnqCode)
    .then(resp => {
      if (resp?.data?.success) {
        setLoading(false);
        let word = convertFourDigitCodeToWord(resp.data.success?.UniqueCode)
        setRecordVideoInstruction({
          instructionPopup: true,
          uniqueCode: resp.data.success?.UniqueCode,
          word:word
        });
        setVideoState(prevState => ({ ...prevState, record: true }));
      } else {
        throw new Error(resp.data.error);
      }
    })
    .catch(err => {
      setLoading(false);
      setSnackBar({ message: err.message, type: "error", show: true });
    });
};

  const handleRefresh = (param) => {
    if (param == codeType) {
      if (isRefreshOn) {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.getDocumentsData)
          .then(resp => {
            if (resp.data.success) {
              setLoading(false)
              let videoDocData = resp.data.success.documentList.filter(item => item.documentTypeCode == "IPV")[0]
              if (videoDocData?.kycstgProofId?.length > 0) {
                linkSentPopup && toggleSentLinkPopup()
                handleClose()
                setSnackBar({ message: localeText?.photoProofDocSuccessfully, type: "success", show: true })
                getDocuments()
              }
              else {
                callRefresh(param)
              }
            }
            else {
              throw new Error(resp.data.error)
            }
          })
          .catch(err => {
            setLoading(false)
          })
      }
    }
  }

  const generateLink = function (param) {
    codeType = param
    isRefreshOn = false
    setCopiedText("")
    setIsCopied({ tab1: false, tab2: false })
    let objections = getObjections()
    let payload = {
        "isObjection": !!(objections),
        "sid": (objections?.filter(objection => objection.navigationPath == "/Upload")[0]?.id) || "0",
        "isReUpload":(getCookie("isEmailMobileVerficationFailed") == true) ? true : false
    }
    setLoading(true)
    axios.post(process.env.REACT_APP_API_URL + config.sendArambhVideoRequest, payload)
        .then(resp => {
            if (resp.data.success) {
                setLoading(false)
                toggleSentLinkPopup()
                isRefreshOn = true
                setCopiedText(resp?.data?.videoRequestlink)
                callRefresh(param)
            } else {
                throw new Error(resp.data.error)
            }
        })
        .catch(err => {
            setLoading(false)
            setSnackBar({ message: err.message, type: "error", show: true })
        })
}
  const callRefresh = (param) => {
    if (param == codeType) {
      if (isRefreshOn) {
        setTimeout(() => handleRefresh(param), 5000)
      }
    }
  }

  return <>
    <Slide direction="left" in={true} mountOnEnter unmountOnExit>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant={"h6"} css={classes.title}>
            <span css={classes.underline}>{localeText?.uploadRecording}</span>
          </Typography>
        </Grid>
        {
          !videoState.record   && <Grid item xs={12}>
            <Typography variant={"subtitle1"}>
              <b>{localeText?.uploadVerification}</b>{localeText?.uploadRegulations}
            </Typography>
          </Grid>
        }
        {
          videoState.record ?
            <Grid item xs={12}>
              <RecordVideo
                cancelRecording={cancelRecording}
                saveRecordVideo={saveRecordVideo}
                uploadVideoProof={uploadVideoProof}
                matches={props.matches}
                recordVideoInstruction={recordVideoInstruction}
                uploadImageProof={uploadImageProof}
                setSnackBar={setSnackBar}
                setLoading={setLoading}
              />
            </Grid>
            :
            <>
              <Grid container css={classes.buttonGrid}>
                {
                  videoState.video.length > 0 ?
                    <Grid container justifyContent={"center"} css={{ position: "relative" }}>
                      <div css={classes.videoBorder}>
                        {
                          !videoState.showLoader && <div onClick={deleteVideo} css={classes.deleteButtonDiv}>
                            <DeleteOutlinedIcon css={classes.deleteIcon} />
                          </div>
                        }
                        <video controls css={classes.video}>
                          <source src={videoState.video[0]} type="video/mp4" />
                        </video>
                        {
                          uploadVideo && uploadVideo.current && uploadVideo.current.files[0] ?
                            <div css={classes.videoNameDiv}>
                              <span css={classes.videoName}>{uploadVideo.current.files[0].name}</span>
                            </div>
                            : null
                        }

                      </div>
                      {
                        uploadVideo && uploadVideo.current && uploadVideo.current.files[0] && uploadVideo.current.files[0].size / (1024 * 1024) > 10 ?
                          <div css={classes.errorDiv}>
                            <span css={classes.errorText}>{localeText?.uploadVideo}</span>
                          </div>
                          : uploadVideo && uploadVideo.current && uploadVideo.current.files[0] && !uploadVideo.current.files[0].name.toLowerCase().includes("mp4") ?
                            <div css={classes.errorDiv}>
                              <span css={classes.errorText}>{localeText?.uploadVideos}</span>
                            </div>
                            : null
                      }
                    </Grid>

                    :
                    <div style={{display: 'flex' , alignItems:'center'}}>
                      <div css={classes.record} onClick={() => setRecordVideoInstruction({ ...recordVideoInstruction, instructionPopup: true })} style={{ display: 'flex' }}>
                        <input ref={uploadVideo} accept={".mp4"} type={"file"} style={{ display: "none" }} />
                        <Grid container spacing={0} style={{ cursor: 'pointer' }}>
                          <Grid item xs={12} css={classes.icon}>
                            <VideocamOutlinedIcon css={{ color: "white" }} />
                          </Grid>
                          <Grid item xs={12} css={classes.iconText}>
                            <span style={{ color: "#fff" }}>{localeText?.uploadRecordVideo}</span>
                          </Grid>
                        </Grid>
                      </div>
                      {recordVideoInstruction?.instructionPopup && <Popup
                        open={recordVideoInstruction?.instructionPopup}
                        maxWidth={"sm"}
                      >
                        <PopupTitle onClose={toggleRecordVideoInstruction} customCSS={{ textAlign: "center",color:'#48B7CC',fontSize: '1.40rem',fontWeight:'700' }}> {localeText?.videoProofDocRegulations}</PopupTitle>
                        <DialogContent>
                          <Typography style={{ color: "#707070",fontSize: '1.20rem',fontWeight:'500' }}>
                            {localeText?.videoProofDocRegulationsTitle}
                          </Typography>
                          <ol>
                            {instructions.map((instruction, index) => (
                              <li key={index}>
                                <p>{instruction}</p>
                              </li>
                            ))}
                          </ol>
                          <Typography align='center'>
                            <Button variant="contained" color="primary" justify="center" onClick={() => handleRecordVideo()}>{localeText?.captureRecordVideo}</Button>
                          </Typography>
                          
                        </DialogContent>
                      </Popup>}
                      <Typography variant="h3" component="div" color="text.secondary" style={{ padding:'10px' }}>{localeText?.UploadVideoOption}</Typography>
                      <div css={classes.uploadWrapper} onClick={() => generateLink("link")} style={{ display: 'flex' }}>
                        <Grid container spacing={0} style={{ cursor: 'pointer' }}>
                          <Grid item xs={12} css={classes.icon}>
                            <CloudUploadOutlinedIcon css={{ color: "black" }} />
                          </Grid>
                          <Grid item xs={12} css={classes.iconText}>
                            <span style={{ color: '#999999' }}>{localeText?.photoProofSendLinkBtn}</span>
                          </Grid>
                        </Grid>
                      </div>
                      {<Popup
                        open={linkSentPopup}
                        maxWidth={"sm"}
                      >
                        <PopupTitle onClose={toggleSentLinkPopup}>Link Sent!</PopupTitle>
                        <DialogContent css={{ textAlign: "center", margin: "0px 30px" }}>
                          <Typography>
                            {localeText?.videoProofFollowTheURL}
                          </Typography>
                          <Button variant="contained" color="primary" css={{ margin: "25px" }} onClick={() => handleRefresh("link")}>
                            {localeText?.photoProofRefreshBtn}
                          </Button>
                          {
                            copiedText &&
                            <Grid>
                              <Grid sx={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', border: '1px solid #ccc', borderRadius: '8px', padding: 0, margin: 0, width: '95%' }}>
                                <Grid paddingX={1} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', height: '35px' }}>
                                  <Typography variant="body2" component="span" style={{ display: 'inline-block', width: "100%", whiteSpace: "nowrap", overflow: 'hidden !important', textOverflow: "ellipsis", overflow: 'hidden' }}>{copiedText}</Typography>
                                </Grid>
                                <Grid sx={{
                                  backgroundColor: '#d3d3d3', cursor: 'pointer', width: '25%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: '35px',
                                  paddingX: 1,
                                  '&:hover': {
                                    background: '#aeaeae',
                                    color: '#ffff'
                                  },
                                  '&:active': {
                                    background: '#676767',
                                    color: '#ffff'
                                  }
                                }} onClick={() => copyLink(copiedText, 2)} >
                                  <Typography>{isCopied?.tab2 ? "Copied" : "Copy Text"}</Typography>
                                </Grid>
                              </Grid>
                              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                                <Typography sx={{ fontStyle: 'italic', fontSize: '12px', m: 1 }}>
                                  Note:- Copy above URL to upload video / Also send on your mobile number
                                </Typography>
                              </Box>
                            </Grid>
                          }
                        </DialogContent>
                      </Popup>}
                    </div>
                }
              </Grid>
              <Grid item xs={12}>
                <Button style={{ boxShadow: '0px 6px 8px -6px #f540405c', marginRight: "10px" }}
                  variant="outlined" onClick={toggleIPVPopup}>
                  {localeText?.uploadBack}
                </Button>
                <Button variant={"contained"} color={"primary"}
                  onClick={() => uploadVideoProof(videoState.video)} disabled={videoState.showLoader || videoState.video.length == 0 || videoState.sizelimit || documentUploadedDetails[0]}>
                  {videoState.showLoader ? <CircularProgress size={24} style={{ marginLeft: '-20px', marginRight: '16px', color: '#00000042' }} /> : ""}
                  {localeText?.uploadNext}
                </Button>
              </Grid>
            </>
        }
      </Grid>
    </Slide>
  </>
}

export default UploadVideo
